import AdminSurveyDetailsPage from "./AdminSurveyDetailsPage";

export default AdminSurveyDetailsPage